import { mapValues } from 'lodash';
/**
 * Version 23 migrations: Add roommate setup settings
 */
export default function v23(website) {
  return {
    ...website,
    eventVersion: 23,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'HotelRequest' && !layoutItem.config.roommateSetupSettings) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            displaySettings: {
              ...layoutItem.config.displaySettings,
              roomSharingPreference: false
            },
            roommateSetupSettings: {
              inviteesCanRequestFullRoom: true,
              allowRoommatePreference: true,
              enteringRoommateOption: 'visible'
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
